import header from './Header'

const selfHeader = {
  install: Vue => {
    Vue.component('myHeader', header)
  }
}

export default selfHeader



// WEBPACK FOOTER //
// ./src/components/header/index.js